// extracted by mini-css-extract-plugin
export default {"Vision":"Vision_Vision__MHIjD","VisionBG":"Vision_VisionBG__tGqva","Wrapper":"Vision_Wrapper__QvGrJ"};